import { render, staticRenderFns } from "./analysisFun1.vue?vue&type=template&id=2da33b02&scoped=true&"
import script from "./analysisFun1.vue?vue&type=script&lang=js&"
export * from "./analysisFun1.vue?vue&type=script&lang=js&"
import style0 from "./analysisFun1.vue?vue&type=style&index=0&id=2da33b02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da33b02",
  null
  
)

export default component.exports